// extracted by mini-css-extract-plugin
export default {"popupClose":"SuccessPopup_popupClose__oUBXa","customBoxshadow":"SuccessPopup_customBoxshadow__scGAu"};